// @flow
import type { AxiosResponse } from "axios";

// Pass set cookie headers back down to the server side response object
const setResponseCookies = (serverResponse) => (response: AxiosResponse) => {
  const { headers } = response;

  const cookies = headers["set-cookie"] || [];

  cookies.forEach((cookie) => serverResponse.append("Set-Cookie", cookie));

  return response;
};

export default setResponseCookies;
